import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'gatsby-plugin-intl';
import Layout from '../../components/layout';
import FormularioContato from '../../components/FormularioContato';

export default ({ location }) => {
  const intl = useIntl();

  return (
    <Layout location={location}>
      <Helmet bodyAttributes={{ class: 'page-template-default page page-id-116 full-width custom-font-enabled single-author mob-menu-slideout' }}>
        <title>{intl.formatMessage({ id: 'Orçamento | Ideia 2001' })}</title>
      </Helmet>

      <div id="primary" className="site-content">
        <div className="tituloProduto mt-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12 pt-3 pb-3 contatoTitulo">
                <h1 className="tt-u m-0">{intl.formatMessage({ id: 'Orçamento' })}</h1>
                <h2>{intl.formatMessage({ id: 'em breve entraremos em contato' })}</h2>
              </div>
            </div>
          </div>
        </div>
        <section>
          <div className="container mb-5">
            <div className="row contato mt-5">
              <div className="col-lg-6 col-md-12">
                <h2>{intl.formatMessage({ id: 'Qual seu produto de' })} <strong>{intl.formatMessage({ id: 'interesse' })}</strong>?</h2>
                <h3>{intl.formatMessage({ id: 'Preencha o formulário abaixo ou clique no ícone do WhatsApp para ser atendido.' })}</h3>
                <FormularioContato formOrcamento />
              </div>
              <div className="col-lg-1 col-md-12"></div>
              <div className="col-lg-5 col-md-12 canais">
                <h3 className="tt-u"><span>{intl.formatMessage({ id: 'termoAuxContato1' })}</span> {intl.formatMessage({ id: 'termoAuxContato2' })}</h3>
                <div className="row mt-4">
                  <div className="col-lg-2 col-md-12">
                    <a href="mailto:contato@ideia2001.com.br" aria-label="icone email">
                      <div className="iconesContato"></div>
                    </a>
                  </div>
                  <div className="col-lg-10 col-md-12 textoContato"><strong>{intl.formatMessage({ id: 'E-mail' })}: </strong>
                    <a style={{ color: '#ffff' }} href="mailto:contato@ideia2001.com.br">
                      contato@ideia2001.com.br
                    </a>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-2 col-md-12">
                    <a href="tel:551129175277" aria-label="icone telefone">
                      <div className="iconesContato2"></div>
                    </a>
                  </div>
                  <div className="col-lg-10 col-md-12 textoContato"><strong>{intl.formatMessage({ id: 'Telefone' })}: </strong>
                    <a style={{ color: '#ffff' }} href="tel:551129175277">55 11  2917-5277</a>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-2 col-md-12">
                    <a href="https://www.google.com/maps/place/Id%C3%A9ia+2001+Inform%C3%A1tica/@-23.6140449,-46.571296,17z/data=!3m1!4b1!4m5!3m4!1s0x94ce5cece2f93775:0xcb66be63d8f4b6fc!8m2!3d-23.6140498!4d-46.5691073" aria-label="icone endereço">
                      <div className="iconesContato3"></div>
                    </a>
                  </div>
                  <div className="col-lg-10 col-md-12 textoContato"><strong>{intl.formatMessage({ id: 'Localização' })}: </strong>
                    <a target="_blank" rel="noreferrer" style={{ color: '#ffff' }} href="https://www.google.com/maps/place/Id%C3%A9ia+2001+Inform%C3%A1tica/@-23.6140449,-46.571296,17z/data=!3m1!4b1!4m5!3m4!1s0x94ce5cece2f93775:0xcb66be63d8f4b6fc!8m2!3d-23.6140498!4d-46.5691073">
                      {intl.formatMessage({ id: 'Rua' })} Amazonas, 363  -  09520-070 - São Caetano - SP
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};
